module.exports = __webpack_public_path__ + "assets/img/8.f0259abe.png";